<template>
    <div class="lc_bg TQ_minHeight_bodyFullScreen"
         :style='{"background-image" : server_questBody_c && `url(${server_questBody_c.qb_theme_c.qbt_backgroundImg_s})`}'>

        <keep-alive>
            <router-view :pe_startWatchPosition_f="m_startWatchPosition_f" :pe_stopWatchPosition_f="m_stopWatchPosition_f"/>
        </keep-alive>

        <!-- popup exit game-->
        <tq-popup :show="showPopup" width="100%"  maxWidth="350px" class="TQ_center" padding="0" :show-close-btn="true">


            <div class="TQ_text_24px TQ_text_bold TQ_bg_purple_dark TQ_padding_8px">{{ass_strings.twoWords_exitQuest[store_system_langCode_v.val]}}</div>

            <div class="TQ_text_16px TQ_padding_16px">{{ass_strings.question_exitQuest[store_system_langCode_v.val]}}</div>

            <div class="TQ_grid_col_Auto1frAuto TQ_padding_8px TQ_border_top">
                <div class="TQ_clickable TQ_padding_8px TQ_box_shadow2 TQ_bg_red TQ_borderRadius TQ_width_80px" @click="showPopup.val = false">
                    {{ass_strings.oneWord_cancel[store_system_langCode_v.val]}}
                </div>
                <div></div>
                <div class="TQ_clickable TQ_padding_8px TQ_box_shadow2 TQ_bg_purple TQ_borderRadius TQ_width_80px"  @click="m_userEvents_onClickExistGame()">
                    {{ass_strings.oneWord_approve[store_system_langCode_v.val]}}
                </div>
            </div>

        </tq-popup>
    </div>
</template>

<script>

    import {
        serverOngoing_gameStatus_vl_set_f,
        serverOngoing_chatMessages_cl_set_f,
        serverOngoing_teamStatus_vl_set_f,
        serverOngoing_teamStatus_vl_remove_f,
        serverOngoing_gameStatus_vl_remove_f,
        serverOngoing_chatMessages_cl_remove,
        serverOngoing_teamPlayerGeoLocation_set,
        serverOngoing_teamStatus_subCollection_cl_get_f,
        serverOngoing_teamStatus_subCollection_cl_remove_f,
        serverOngoing_teamPlayerInfo_update_f,
        serverOngoing_chatMessage_receive_f, 
    } from "../scripts/Server/S_ServerOngoing";
    import {
        serverBig_questBody_once_fp,
    } from "../scripts/Server/S_ServerFirestore";
    import {notification_notify} from "../scripts/S_Notification";
    import {store_var, store_getStateValue_vo} from "../store";
    import {
        enum_cluesMode_e,
        enum_mapMissionsTypes,
        enum_vibrationPatterns,
    } from "../../functions/src/shareCode/Share_S_Enum";
    import {store_setStateValue} from "../store";
    import TqPopup from "../components/basic/TqPopup";
    import {route_moveToRoute, route_refreshPage} from "../router";
    import {ass_strings} from "../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        date_doEveryClockTick_addCb_f,
        date_doEveryClockTick_removeCb_f, date_getTimePastInSeconds_fn,
    } from "../scripts/S_Date";
    import {file_playAudio_f} from "../scripts/S_Files";
    import {
        serverAuth_getOtherUserData_f
    } from "../scripts/Server/S_ServerAuth";
    import TqCard from "../components/basic/TqCard";
    import {obj_forEach_f} from "../../functions/src/shareCode/Share_S_Obj";
    import {
        ass_audio_finishLastRiddle,
        ass_img_shareLocation,
        ass_img_locationOff,
        ass_img_exit_b
    } from "../assets/scripts/Ass_Files";
    import {obj_deepCopy_f, obj_equals_fb, obj_size_fn} from "../../functions/src/shareCode/Share_S_Obj";
    import {
        helper_finishRiddle_fb,
        helper_getEventClockStatus_e,
        helper_millSecToEndingQuest_n,
        helper_millSecToStartingQuest_t,
        helper_getRiddleWithRiddleId_fc,
        helper_getDistanceBetweenTwoPoints_fn,
    } from "../scripts/S_Helper";
    import {
        navigator_vibrate_f,
    } from "../scripts/S_Navigator";
    import {ass_navTabs} from "../assets/scripts/Ass_NavTabs";
    import {
        enum_questEventStatus,
        enum_moveToOptions, enum_notifyComponent,
        enum_subCollection_teamStatus,
        enum_arrangeMissionsType_s
    } from "../../functions/src/shareCode/Share_S_Enum";
    import {gv_numbers} from "../../functions/src/shareCode/Share_Ass_GlobalVariable";
    import {serverAuth_currentUserData_get_vl_fp, serverAuth_currentUserData_remove_vl_f} from "../scripts/Server/S_ServerAuth";
    import {
        webAppManager_geoLocationListener_set_f,
        webAppManager_geoLocationListener_stop_f, webAppManager_getBatteryLevel_f,
    } from "../scripts/S_WebAppMediator";
    import TqImage from "@/components/basic/TqImage";
    import {FB_TeamPlayerInfo, FB_UserGeoLocation} from "../../functions/src/shareCode/Share_S_Classes";

    export default {
        name: "V_Ongoing",
        components: {TqImage, TqCard, TqPopup},
        data() {
            return {

                showPopup               : {val : false},
                showPopup_review        : {val : true},

                exitCB                  : null,
                secondsPast_n           : 0,
                sumPlayerWalkInMeters_n : 0,
                setTeamStatusListeners_b : false,
            
                lastBattry              : null,
                finishLocksNotify_byRiddleId_b : {},
                notify_byId_n : {},

                // server
                server_questBody_c             : undefined,

                // store
                store_app_qrScannerCb_vf                        : store_getStateValue_vo(store_var.ongoing_qrScannerCb_f),
                store_questEvent_c                              : store_getStateValue_vo(store_var.ongoing_questEvent).val,
                store_system_langCode_v                         : store_getStateValue_vo(store_var.system_langCode),
                store_system_position_vc                        : store_getStateValue_vo(store_var.system_currentUserLocation),
                store_system_position_old_c                     : null,
                store_ongoing_eventCurrentStatus_ve             : store_getStateValue_vo(store_var.ongoing_eventCurrentStatus),
                store_ongoing_currentTeamId_vUid                : store_getStateValue_vo(store_var.ongoing_currentTeamId_uid),
                store_navBar_showedBeacon_byPath_b              : store_getStateValue_vo(store_var.navBar_showedBeacon_byPath_b).val,

                // server
                server_currentUserData_c : undefined,
                server_gameStatus_c      : undefined,
                server_teamStatus_c      : undefined,

                // assents
                ass_strings : ass_strings,
            }
        },
        computed : {
            co_playerNeedToSelectPath_b(){

                let playerChoosePath_b = this.server_gameStatus_c &&
                    this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val] &&
                    this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val].gst_players_byUserId_c[this.server_currentUserData_c.ud_userId_uid] &&
                    this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val].gst_players_byUserId_c[this.server_currentUserData_c.ud_userId_uid].gstp_pathIndex_n

                let gameSupportPlayerChooseOneTime_b = this.server_questBody_c.qb_metadata_c.qbm_quest_missionsArrangements_e === enum_arrangeMissionsType_s.player_choose_oneTime

                return playerChoosePath_b == null && gameSupportPlayerChooseOneTime_b
            }
        },
        methods:{

            // m_watchPosition_f
            m_stopWatchPosition_f(){
                webAppManager_geoLocationListener_stop_f(this.$options.name)
                store_setStateValue(store_var.system_currentUserLocation, null)
                this.update_navBarMenu_f(false)
            },
            m_startWatchPosition_f(){

                webAppManager_geoLocationListener_set_f(this.$options.name,(userGeoLocation_c) => {

                    if(this.server_currentUserData_c == null){
                        return
                    }

                    this.update_navBarMenu_f(true)

                    userGeoLocation_c.ugl_userId_uid = this.server_currentUserData_c.ud_userId_uid
                    store_setStateValue(store_var.system_currentUserLocation, userGeoLocation_c)

                })

            },

            // m_doEveryClockTick_f
            m_doEveryClockTick_f(){

                this.secondsPast_n++

                // 1) set game clockStatus
                if(this.store_questEvent_c){

                    let millSecToStart_n = helper_millSecToStartingQuest_t(this.store_questEvent_c, this.server_gameStatus_c, this.store_ongoing_currentTeamId_vUid.val)

                    let millSecToEnd_n = helper_millSecToEndingQuest_n(millSecToStart_n, this.store_questEvent_c, this.server_gameStatus_c)

                    let questEvent_clockStatus_e = helper_getEventClockStatus_e(millSecToStart_n, millSecToEnd_n)

                    // 1) set time to end quest
                    if(questEvent_clockStatus_e === enum_questEventStatus.ongoing){
                        store_setStateValue(store_var.ongoing_millSecToEndQuest_n, millSecToEnd_n)
                    }

                    // 2) set ongoing_clock status
                    if(this.store_ongoing_eventCurrentStatus_ve.val !== questEvent_clockStatus_e){
                        store_setStateValue(store_var.ongoing_eventCurrentStatus, questEvent_clockStatus_e)
                    }
                }

                // 2) sum walking every second
                if( this.store_system_position_vc.val
                    && !obj_equals_fb(this.store_system_position_old_c, this.store_system_position_vc.val)){

                    // sum player walk
                    if(this.store_system_position_old_c != null){

                        let walkInMeters_oneSeconds = helper_getDistanceBetweenTwoPoints_fn(
                            this.store_system_position_old_c.ugl_latitude_n, this.store_system_position_old_c.ugl_longitude_n,
                            this.store_system_position_vc.val.ugl_latitude_n, this.store_system_position_vc.val.ugl_longitude_n)

                        if(walkInMeters_oneSeconds < 10 ) {
                            this.sumPlayerWalkInMeters_n += walkInMeters_oneSeconds
                        }
                    }

                    this.store_system_position_old_c = new FB_UserGeoLocation(obj_deepCopy_f(this.store_system_position_vc.val))
                }

                // 3) update teamPlayer location every 5 seconds
                if(this.secondsPast_n % 5 === 0 ){

                    if(this.store_system_position_vc.val && this.store_ongoing_currentTeamId_vUid.val){
                        serverOngoing_teamPlayerGeoLocation_set(
                            this.store_questEvent_c.qev_questId_uid,
                            this.store_questEvent_c.qev_eventId_uid,
                            this.store_ongoing_currentTeamId_vUid.val,
                            this.store_system_position_vc.val)
                    }

                }

                // 4) update team player info every 10 seconds
                if(this.secondsPast_n % 30 === 0 && this.server_currentUserData_c) {

                    webAppManager_getBatteryLevel_f( (batteryLevel) => {

                        if(this.lastBattry == batteryLevel || batteryLevel === -1){
                            return
                        }
                        this.lastBattry = batteryLevel

                        const playerMoreInfo_c = new FB_TeamPlayerInfo({
                            pmi_batteryLevel_n  : batteryLevel,
                            pmi_walkInMeters_n  : this.sumPlayerWalkInMeters_n
                        });

                        this.sumPlayerWalkInMeters_n = 0

                        serverOngoing_teamPlayerInfo_update_f({
                            teamPlayerInfo_c    : playerMoreInfo_c,
                            userId_uid          : this.server_currentUserData_c.ud_userId_uid,
                            questEvent_c        : this.store_questEvent_c,
                        });
                    })
                }
            },

            // ========== mounted =========
            mounted_getGameStatus(cb_f){

                serverOngoing_gameStatus_vl_set_f(
                    this.$options.name,
                    this.store_questEvent_c.qev_questType_e,
                    this.store_questEvent_c.qev_questId_uid,
                    this.store_questEvent_c.qev_eventId_uid,
                    true,
                    gameStatus_c => {

                        // remove player from team
                        if( gameStatus_c != null &&
                            !gameStatus_c.cm_gs_userIdExist_fb(this.server_currentUserData_c.ud_userId_uid) &&
                            this.store_ongoing_currentTeamId_vUid.val != null){

                            store_setStateValue(store_var.ongoing_currentTeamId_uid, null)

                            route_moveToRoute(enum_moveToOptions.ongoing_status)

                            route_refreshPage()
                        }
                        this.server_gameStatus_c = gameStatus_c

                        cb_f(gameStatus_c)

                })

            },
            mounted_getTeamStatus(questEvent_c, teamId_uid){
                serverOngoing_teamStatus_vl_set_f({
                    viewName_s: this.$options.name, 
                    questEvent_c, 
                    teamId_uid,
                    cacheFallback_b: true, 
                    cb_f: (newTeamStatus_c) => {

                        // notification
                        if(newTeamStatus_c != null && this.server_teamStatus_c){
                            // 1) got clue
                            if(newTeamStatus_c.ts_cluesLeft_n > this.server_teamStatus_c.ts_cluesLeft_n){
                                notification_notify(ass_strings.threeWords_earnedAHint, null)
                            }
                            // 2) use clue
                            else if(newTeamStatus_c.ts_cluesLeft_n < this.server_teamStatus_c.ts_cluesLeft_n){
                                notification_notify(ass_strings.threeWords_usedAHint, null)
                            }
                            // 1) got skip
                            if(newTeamStatus_c.ts_skipsLeft_n > this.server_teamStatus_c.ts_skipsLeft_n){
                                notification_notify(ass_strings.threeWords_earnedASkip, null)
                            }
                        }

                        // update teamStatus
                        this.server_teamStatus_c = newTeamStatus_c

                        // refresh store
                        this.refresh_storeSkipsAndClues_f()

                        }     
                })
                
            },

            created_teamStatus_subCollection(questEvent_c){


                // check pre att
                if(this.store_ongoing_currentTeamId_vUid.val == null || this.server_questBody_c == null || this.setTeamStatusListeners_b){
                    return
                }

                this.setTeamStatusListeners_b = true

                // set server listeners
                obj_forEach_f(enum_subCollection_teamStatus, (subCollection_teamStatus_e) => {
                    serverOngoing_teamStatus_subCollection_cl_get_f({
                        viewName_s          : this.$options.name,
                        subCollectionName_e : subCollection_teamStatus_e,
                        questEvent_c        : questEvent_c,
                        teamId_uid          : this.store_ongoing_currentTeamId_vUid.val,
                        cb_ChildAdded_f     : (riddleStatus_c) => {

                            let riddleData_c;
                            let audioUrl_s;

                            switch(subCollection_teamStatus_e){
                                case enum_subCollection_teamStatus.MAP_MISSIONS:
                                    riddleData_c = helper_getRiddleWithRiddleId_fc(this.server_questBody_c.qb_mapMissions_ac, riddleStatus_c.rs_riddleId_n)
                                    audioUrl_s = this.server_questBody_c.qb_metadata_c.qbm_audio_mapMissionsUrl_s
                                    break;

                                case enum_subCollection_teamStatus.MAP_LAST_MISSIONS:
                                    riddleData_c = helper_getRiddleWithRiddleId_fc(this.server_questBody_c.qb_mapLastMissions_ac, riddleStatus_c.rs_riddleId_n)
                                    audioUrl_s = this.server_questBody_c.qb_metadata_c.qbm_audio_mapMissionsUrl_s
                                    break;

                                case enum_subCollection_teamStatus.CARDS_MISSIONS:
                                    riddleData_c = helper_getRiddleWithRiddleId_fc(this.server_questBody_c.qb_cardsMissions_ac, riddleStatus_c.rs_riddleId_n)
                                    audioUrl_s = this.server_questBody_c.qb_metadata_c.qbm_audio_cardsMissionsUrl_s
                                    break;

                                case enum_subCollection_teamStatus.LIST_MISSIONS:
                                    riddleData_c = helper_getRiddleWithRiddleId_fc(this.server_questBody_c.qb_listMissions_ac, riddleStatus_c.rs_riddleId_n)
                                    audioUrl_s = this.server_questBody_c.qb_metadata_c.qbm_audio_listMissionsUrl_s
                                    break;

                                case enum_subCollection_teamStatus.LIST_LAST_MISSIONS:
                                    riddleData_c = helper_getRiddleWithRiddleId_fc(this.server_questBody_c.qb_listLastMissions_ac, riddleStatus_c.rs_riddleId_n)
                                    audioUrl_s = this.server_questBody_c.qb_metadata_c.qbm_audio_listMissionsUrl_s
                                    break;
                            }

                            this.mounted_teamStatus_SubCollection_handleNotification_f({
                                qb_riddleData_c         : riddleData_c,
                                riddleStatus_c          : riddleStatus_c,
                                audio_assent            : audioUrl_s,
                            })

                        },
                    })
                })
            },
            mounted_teamStatus_SubCollection_handleNotification_f({qb_riddleData_c, riddleStatus_c, audio_assent}) {

                const riddleStatusLastActionTimestamp_t = riddleStatus_c.cm_rs_lastUpdateTimestamp_t()
                const riddleId_n = qb_riddleData_c.qbr_riddleId_n

                if( !this.notify_byId_n[riddleId_n]
                    && date_getTimePastInSeconds_fn(riddleStatusLastActionTimestamp_t) < gv_numbers.relevantRiddleStatus_seconds
                    && helper_finishRiddle_fb(qb_riddleData_c, riddleStatus_c)){

                    this.notify_byId_n[riddleId_n] = true 
                    file_playAudio_f(audio_assent)

                    navigator_vibrate_f(enum_vibrationPatterns.success)
                    notification_notify(ass_strings.twoWords_missionComplete, null, enum_notifyComponent.si_finishRiddle, 4000)
                }

            },
            mounted_getChatMessages(questEvent_c, teamId_uid){

                let msgReadStatus_byTimeSend_b = {}

                serverOngoing_chatMessages_cl_set_f(
                    this.$options.name,
                    this.server_currentUserData_c.ud_userId_uid,
                    questEvent_c,
                    teamId_uid,
                    (msg_c) => {

                        // 1) first time msg
                        if(msg_c.ms_receiveMsg_byUserId_b[this.server_currentUserData_c.ud_userId_uid] == null) {

                            serverAuth_getOtherUserData_f(msg_c.ms_senderId_uid, (userData_c) =>{
                                // webAppManager_notification_f(userData_c.ud_name_s, msg.ms_text_s)
                                file_playAudio_f(this.server_questBody_c.qb_metadata_c.qbm_audio_chatUrl_s);
                                serverOngoing_chatMessage_receive_f(questEvent_c, teamId_uid, msg_c, this.server_currentUserData_c.ud_userId_uid)
                            })
                            // charged message
                        }
                        msgReadStatus_byTimeSend_b[msg_c.ms_sendTime_n] = msgReadStatus_byTimeSend_b[msg_c.ms_sendTime_n]
                            || msg_c.ms_readMsg_byUserId_b[this.server_currentUserData_c.ud_userId_uid] != null

                        let ans_n = 0
                        obj_forEach_f(msgReadStatus_byTimeSend_b, readMsg_b => {
                            if(!readMsg_b) ans_n++
                        })

                        ass_navTabs.ongoing_chat.notification_n = ans_n

                    })

            },

            // ========= refresh =============
            refresh_navBar_f(){

                this.m_doEveryClockTick_f()

                //  didnt choose team
                if(this.store_ongoing_currentTeamId_vUid.val == null || this.server_questBody_c == null){
                    store_setStateValue(store_var.navBar_tabs_ac, [])
                    return
                }

                let ans_ao = [ass_navTabs.ongoing_status, ass_navTabs.ongoing_questRules]

                // chat
                if( this.server_questBody_c.qb_metadata_c.qbm_quest_supportChat_b){
                    ans_ao.push(ass_navTabs.ongoing_chat);
                }

                // ongoing quest
                if(this.store_ongoing_eventCurrentStatus_ve.val === enum_questEventStatus.ongoing && !this.co_playerNeedToSelectPath_b){

                    // missions
                    if(this.server_questBody_c.qb_metadata_c.qbm_quest_supportListMissions_b){
                        ans_ao.push(ass_navTabs.ongoing_missions);
                    }
                    // cards or openMap
                    if(this.server_questBody_c.qb_metadata_c.qbm_quest_supportCardsMissions_b) {
                        ans_ao.push(ass_navTabs.ongoing_cards)
                    }
                    else if(this.server_questBody_c.qb_metadata_c.qbm_quest_supportMapMissions_b) {

                        if(this.server_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.polygons_area){
                            ans_ao.push(ass_navTabs.ongoing_polygonMap)
                        }else{
                            ans_ao.push(ass_navTabs.ongoing_map)
                        }
                    }
                }

                // tabs
                store_setStateValue(store_var.navBar_tabs_ac, ans_ao)

            },
            update_navBarMenu_f(gpsLocationEnabled_b){

                let ans_oa = []

                let enableLocation_o    = {img_r : ass_img_shareLocation, text_blc_s    : ass_strings.twoWords_enableLocation,  onClickDo_f : () => { this.m_startWatchPosition_f()}}
                let disableLocation_o   = {img_r : ass_img_locationOff, text_blc_s      : ass_strings.twoWords_disableLocation, onClickDo_f : () => { this.m_stopWatchPosition_f()}}
                let exitQuest_o         = {img_r : ass_img_exit_b, text_blc_s           : ass_strings.twoWords_exitQuest,       onClickDo_f : () => { route_moveToRoute(enum_moveToOptions.player_play_list)}}

                if(this.server_questBody_c && this.server_questBody_c.qb_metadata_c.qbm_mapMissions_showGpsBtn_b && this.server_questBody_c.qb_metadata_c.qbm_quest_supportMapMissions_b){
                    ans_oa.push(gpsLocationEnabled_b ? disableLocation_o : enableLocation_o)
                }
                ans_oa.push(exitQuest_o)

                store_setStateValue(store_var.navBar_menu_ac, ans_oa)
            },
            refresh_storeSkipsAndClues_f(){

                if(this.server_questBody_c == null|| this.server_teamStatus_c == null){
                    return
                }


                if(this.server_questBody_c && this.server_questBody_c.qb_metadata_c.qbm_missions_supportSkips_b){
                    store_setStateValue(store_var.ongoing_skipsNum_n, this.server_teamStatus_c.ts_skipsLeft_n)
                }

                if(this.server_questBody_c && [enum_cluesMode_e.counter, enum_cluesMode_e.counter_gradual].includes(this.server_questBody_c.qb_metadata_c.qbm_missions_cluesMode_e)){
                    store_setStateValue(store_var.ongoing_cluesNum_n, this.server_teamStatus_c.ts_cluesLeft_n)
                }
            },
            m_updateTotalScore_f(){


                let totalScore_n = null
                if(this.server_questBody_c && this.server_questBody_c.qb_metadata_c.qbm_missions_supportMissionsPoints_b){

                    if(this.server_gameStatus_c && this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val]){
                        totalScore_n = (this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val].gst_m_totalPoints_n())
                    }else{
                        totalScore_n = 0

                    }
                }

                store_setStateValue(store_var.ongoing_currentScore_n, totalScore_n)

            },

            // ========== user events =========
            m_userEvents_onClickExistGame(){
                if(this.exitCB)
                    this.exitCB()
            },

        },

        // ===== life circles =======
        async mounted() {

            // 1) get quest body
            this.server_questBody_c = await serverBig_questBody_once_fp(this.store_questEvent_c.qev_questType_e, this.store_questEvent_c.qev_questId_uid, false, true);

            // 2) clean
            this.refresh_navBar_f()
            this.refresh_storeSkipsAndClues_f()
            this.update_navBarMenu_f(false)
            this.m_updateTotalScore_f()

            // 3) set team status subCollections
            this.created_teamStatus_subCollection(this.store_questEvent_c)

            // 4) get currentUserData
            await serverAuth_currentUserData_get_vl_fp(this.$options.name, (userData_c) => {
                this.server_currentUserData_c = userData_c;
            })

            // 5) set game status
            let firstCall_gameStatus_b = true
            this.mounted_getGameStatus((gameStatus_c) => {

                if (gameStatus_c === null) {
                    return
                }

                let teamId_uid = gameStatus_c.cm_gs_getTeamIdByUserId_fuid(this.server_currentUserData_c.ud_userId_uid)

                store_setStateValue(store_var.ongoing_currentTeamId_uid, teamId_uid)

                this.refresh_navBar_f()

                // check userChooseTeam
                if (!teamId_uid) {
                    return
                }

                // finish quest notification
                if (gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_finishTime_t != null) {

                    if (!this.notify_byId_n["lastRiddle"] && date_getTimePastInSeconds_fn(gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_finishTime_t) < gv_numbers.relevantRiddleStatus_seconds) {
                        this.notify_byId_n["lastRiddle"] = true
                        file_playAudio_f(this.server_questBody_c.qb_metadata_c.qbm_audio_lastMissionsUrl_s)
                        notification_notify(null, null, enum_notifyComponent.si_finishQuest, 8000)
                    }
                }

                // show status beacon
                if (this.store_ongoing_eventCurrentStatus_ve.val === enum_questEventStatus.finish
                    || gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_finishTime_t != null) {
                    ass_navTabs.ongoing_status.showBeacon_b = true
                } else {
                    ass_navTabs.ongoing_status.showBeacon_b = false
                }


                // update topBarTotalScore
                this.m_updateTotalScore_f()

                // check first call
                if (!firstCall_gameStatus_b) {
                    return
                }
                firstCall_gameStatus_b = false

                // 5.1) set team status
                this.mounted_getTeamStatus(this.store_questEvent_c, teamId_uid)

                // 5.2) set team chat and side missions
                this.mounted_getChatMessages(this.store_questEvent_c, teamId_uid);

                // 5.3) set team status subCollections
                this.created_teamStatus_subCollection(this.store_questEvent_c)

            })

            // 6) set do every clock tick
            date_doEveryClockTick_addCb_f(this.$options.name, this.m_doEveryClockTick_f)

            // 7) watch position
            if (this.store_system_position_vc.val != null) {
                this.m_startWatchPosition_f()
            }

        },
        destroyed(){

            // stop ongoing clock
            date_doEveryClockTick_removeCb_f(this.$options.name)

            // store remove cardRiddles_LastIndex
            store_setStateValue(store_var.ongoing_cardsRiddles_lastIndex_n, null)

            // remove currentUserData Listener
            serverAuth_currentUserData_remove_vl_f(this.$options.name)

            // gameStatus
            serverOngoing_gameStatus_vl_remove_f(this.$options.name, this.store_questEvent_c)

            if(this.server_gameStatus_c && this.server_currentUserData_c){
                let teamId = this.server_gameStatus_c.cm_gs_getTeamIdByUserId_fuid(this.server_currentUserData_c.ud_userId_uid)

                if(teamId){
                    // 2) teamStatus
                    serverOngoing_teamStatus_vl_remove_f(this.$options.name, this.store_questEvent_c, teamId)

                    // 3) chat messages
                    serverOngoing_chatMessages_cl_remove(this.$options.name, this.store_questEvent_c, teamId)
                }
            }

            // geoLocations stop
            webAppManager_geoLocationListener_stop_f(this.$options.name)

            // remove teamStatus subCollection
            obj_forEach_f(enum_subCollection_teamStatus, (subCollection_teamStatus_e) => {
                serverOngoing_teamStatus_subCollection_cl_remove_f({
                    viewName_s          : this.$options.name,
                    subCollectionName_e : subCollection_teamStatus_e,
                    questEvent_c        : this.store_questEvent_c,
                    teamId_uid          : this.store_ongoing_currentTeamId_vUid.val,
                })
            })

            // store remove currentTeamId
            store_setStateValue(store_var.ongoing_currentTeamId_uid, null)

        },

        beforeRouteUpdate(to, from, next){

            for(let key_s in ass_navTabs){

                let navTab_o = ass_navTabs[key_s]

                if( to.path.includes(navTab_o.path)
                    && navTab_o.showBeacon_b
                    && navTab_o.path !== enum_moveToOptions.ongoing_status){

                    // updateLocal navTab
                    navTab_o.showBeacon_b = false

                    // update store
                    this.store_navBar_showedBeacon_byPath_b[navTab_o.path] = true
                    store_setStateValue(store_var.navBar_showedBeacon_byPath_b, this.store_navBar_showedBeacon_byPath_b)

                    break;
                }
            }
            next()
        },
        beforeRouteLeave (to, from, next) {

            this.showPopup.val = true

            this.exitCB = () => {
                this.exitCB = null
                next()
            }
        }

    }
</script>

<style scoped lang="scss">
    .lc_bg{
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
    }

</style>